export enum ElementDistribution {
    Horizontal,
    Vertical
}
